module.exports = __webpack_public_path__ + "static/media/Andrew-1.081b44e7.png";